import isString from 'lodash/fp/isString'
import { Store } from 'redux'

export const retrieveError = (error: any) => {
  const data = error?.response?.data

  if (isString(data)) {
    return data
  }

  return data && data.Error
}

export const credentials = (store: Store) => {
  const state = store.getState()

  const emailAddress = state?.auth?.user?.email
  const token = state?.auth?.tokens?.RefreshToken
  const lastRefreshRequest = state?.auth?.user?.lastRequested

  return { emailAddress, token, lastRefreshRequest }
}

export const isValidationError = (error: any) => !!error?.response?.data?.ValidationErrors
